import React from 'react';
import { StarList } from './styles';
import ContentIcon from '../../ContentIcon';
import TemplateContext from '@/context/Template/TemplateContext';

export const ReviewStars = ({ dataReview }) => {
    const { numberOfStars = 0, numberOfReviews = 0 } = dataReview || {};

    const rating = numberOfReviews > 0 ? (numberOfStars / numberOfReviews) : 0;
    const normalizedRating = Math.min(5, rating);

    const renderStars = () => {
        const totalStars = 5;
        const filledStars = Math.floor(normalizedRating);
        const hasHalfStar = normalizedRating % 1 >= 0.5;

        return [...Array(totalStars)].map((_, i) => {
            let className = 'empty';
            if (i < filledStars) className = 'filled';
            else if (i === filledStars && hasHalfStar) className = 'half';

            return (
                <span key={i} className={className}>
                    <ContentIcon width="14px" height="14px" nameIcon="star" />
                </span>
            );
        });
    };

    return (
        <StarList>
            <div className="stars">{renderStars()}</div>
        </StarList>
    );
};